<script setup>
  import partnrUpLogo from '@/assets/logo/PartnrUP_Full.svg';
  import UserAvatarDropDown from '@/components/UserAvatarDropDown.vue';
  import { useLayoutStore } from '@/stores/layout.store.js';
  import { useRoute } from 'vue-router';

  const route = useRoute();

  const props = defineProps({
    color: {
      type: String,
      default: 'white',
    },
  });

  const toggleSideNav = () => {
    if (route.path.startsWith('/settings/')) {
      useLayoutStore().toggleSettingsNavigationSideBar();
    } else {
      useLayoutStore().toggleMobileNavigationSideBar();
    }
  };
</script>

<template>
  <v-app-bar class="tw-shadow-secondary" density="compact" :color="color">
    <div class="tw-mx-3 tw-flex tw-w-full tw-py-1">
      <div class="tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-between lg:tw-px-4 lg:tw-pl-4">
        <v-btn class="tw-block xl:tw-hidden" density="comfortable" icon="mdi-menu" @click.stop="toggleSideNav()"></v-btn>
        <RouterLink to="/">
          <v-img :width="112" :src="partnrUpLogo" :lazy-src="partnrUpLogo"></v-img>
        </RouterLink>
        <div>
          <UserAvatarDropDown />
        </div>
      </div>
    </div>
  </v-app-bar>
</template>

<style scoped lang="css"></style>
